import React from 'react'

const About = () => {
  return (
    <main className='About'>
       <h1>ABOUT:-</h1>
      <p>
      Hi all i am pavithran.I am passionate about all things in JavaScript. I work hard. I care about writing clean code and genuinely love to learn code. I am currently looking for the right opportunity to work in an environment that will help me progress to a front-end developer
      </p>
    </main>
  )
}

export default About